<template>
    <div class="segmented-control">
        <button type="button" class="btn" v-for="segment in segments" :class="{ selected: isSelected(segment) }" @click="onSelect(segment)">
            {{ segment.label }}
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: [Number, String],
                required: true,
            },
            segments: {
                type: Array,
                required: true,
            },
        },
        methods: {
            onSelect (segment) {
                console.log(segment);
                this.$emit('input', segment.value);
            },
            isSelected (segment) {
                return segment.value === this.value;
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/bootstrap.scss';
    .segmented-control {
        display: flex;
        flex-direction: row;
        border-radius: 5px;
        border: solid 1px theme-color('primary');
        > button {
            flex: 1;
            color: theme-color('primary');
            border-radius: 0;
            border-right: solid 1px theme-color('primary');
        }
        > button:hover {
            color: theme-color('primary');
        }
        > button:last-child {
            border: none !important;
        }
        > button.selected {
            color: white;
            background-color: theme-color('primary');
        }
    }
</style>
